import { z } from 'zod';
import { NotificationRecurrenceType, NotificationSendVia } from '../enums';

const NotificationCenterTranslationDto = z.object({
  locale: z.string().min(1),
  title: z.string().min(1).max(255),
  body: z.string().min(1),
});

export const CreateNotificationCenterDto = z
  .object({
    translations: z.array(NotificationCenterTranslationDto).min(1),
    recurrenceType: z.nativeEnum(NotificationRecurrenceType),
    recurrenceInterval: z.number().int().positive().optional(),
    startDate: z.coerce.date().optional(),
    endDate: z.coerce.date().optional(),
    customDates: z.array(z.coerce.date()).optional(),
    sendVia: z.array(z.nativeEnum(NotificationSendVia)).min(1),
    clientIds: z.array(z.string().uuid()).min(1),
  })
  .strict();

export type ApiCreateNotificationCenterDto = z.infer<
  typeof CreateNotificationCenterDto
>;

export const UpdateNotificationCenterDto =
  CreateNotificationCenterDto.partial();

export type ApiUpdateNotificationCenterDto = z.infer<
  typeof UpdateNotificationCenterDto
>;
